import React, { useState, useRef } from 'react';

//Importar dependecias para la ventana modal.
import Dialog from '@mui/material/Dialog';

//Iconos de Material UI.
import { Close, Image, GetApp } from '@mui/icons-material/';
import { IconButton } from '@mui/material';

//Importar dependencias para el zoom.
import PrismaZoom from 'react-prismazoom';
import { downloadFileFromUrl } from '../../../../../helpers/downloadFileFromUrl.js';
import { getFileNameFromUrl } from '../../../../../helpers/getFileNameFromUrl.js';
import BtnActionModal from '../../../../common/Buttons/BtnActionModal.jsx';
import CarouselImagesInChat from '../Components/CarouselImagesInChat.jsx';

// MessageTypeImageInChat: componenete que renderiza un mensaje del tipo imagen
// dentro del chat de la sesión.

const MessageTypeImageInChat = ({ src, alt, entrante, mensaje, messageData }) => {

  const [open, setOpen] = useState(false); //Estado para abrir y cerrar la vista de imagen.
  const imageRef = useRef(null); //Referencia para la imagen.

  const handleDownloadFile = () => { //Función para descargar el archivo multimedia.
    let nameFile = getFileNameFromUrl(src);
    downloadFileFromUrl(src, nameFile);
  };
  return (
    <>

      {/*----------Contenedor de la imagen dentrod el chat---------------- ---------*/}
      <div className='container-message__image-with-text'>

        {/*---------------Contenedor del mensaje tipo imagen------------------- */}
        <div className='container-message__image'>

          {/*--------Contenedor de la burbuja del mensaje tipo imagen----------------- */}
          <div className={`container-image-message ${entrante ? "entrante" : "saliente"}`}>

            {/*--------Contenedor de la imagen con el icono de imagen-----------*/}
            <div className='container-image-with-imageIcon'>
              {/*-------------Imagen del mensaje---------------- */}
              <img src={src} alt={alt} className="new-image" onClick={() => setOpen(true)} ref={imageRef} />
              {/*-----------------Icono de imagen----------------*/}
              <Image className='container-new-image__icon' style={{ position: 'absolute', bottom: '7px', right: '7px', fontSize: "22px" }} />
            </div>

          </div>
        </div>

        {mensaje && <span className={`message-image__text ${entrante ? "entrante" : "saliente"}`}>{mensaje}</span>}
      </div>

      {/*----------Contenedor de la imagen dentro de la Ventana Modal ---------*/}
      <Dialog fullScreen open={open} /*  onClose={handleClose} */>
        <div className='container-image-modal'>
          {/*------Contenedor del boton para cerrar el modal----- */}
          <div className='container-btn__close'>
            <BtnActionModal onClick={handleDownloadFile}>
              <GetApp sx={{ fontSize: "22px" }} />
            </BtnActionModal>
            <BtnActionModal onClick={() => setOpen(false)}>
              <Close sx={{ fontSize: "22px" }} />
            </BtnActionModal>
          </div>

          {/*----------Contenedor de la imagen zoomable---------- */}
          <div className='container-image__zoomable'>
            <PrismaZoom>
              <div className="zoomable-image"  >
                <img src={src} alt={alt} className="image" />
              </div>
            </PrismaZoom>
          </div>
{/*           <CarouselImagesInChat src={src} messageData={messageData}/> */}
        </div>
      </Dialog>

    </>
  )
};

export default MessageTypeImageInChat;
